import { cond, get, stubTrue, flow, compact } from 'lodash-es';
import { isNew } from 'site-modules/shared/utils/inventory-utils/is-new';
import { isPartnerDealer, isPrivateParty } from 'site-modules/shared/utils/dealer-details-utils';
import { BOL_VDP_DEALERS } from 'site-modules/shared/constants/inventory/buy-online-dealers';
import { CTA_TEXT, CTA_TYPE } from 'site-modules/shared/constants/inventory/lead-form';
import { BUTTON_TYPES } from 'site-modules/shared/components/inventory/contact-dealer/sticky-bar/utils/button-types';

export const getButtonsConfig = ({
  vinData,
  hideLeadForm,
  leadFormCtas,
  isCaramelOptInDealer,
  ignoreBolTreatment,
  privateListingData,
  dealer: dealerInfo,
  ted7485Recipe,
  enableCaramel,
  isShop5146NciCopyChallenge = false,
}) => {
  const phoneNumber = get(vinData, 'computedDisplayInfo.phoneNumber', '');
  const dealer = get(vinData, 'dealerInfo.displayInfo.parentDealershipName');

  const isPartnerListing = isPartnerDealer(vinData);
  const isPrivatePartyListing = isPrivateParty(vinData);
  const isUsed = !isNew(vinData.type);
  const isBolEnabledDealer = BOL_VDP_DEALERS.includes(dealer);

  function isPurchaseButton() {
    return (
      !dealerInfo?.dealStatus &&
      ((isPrivatePartyListing && privateListingData?.listingId && enableCaramel) ||
        (isUsed && (!isPartnerListing || hideLeadForm) && isCaramelOptInDealer))
    );
  }

  function isDeliveryButton() {
    return isBolEnabledDealer && isUsed && isPartnerListing && !ignoreBolTreatment;
  }

  function isLeadFormButton() {
    return !hideLeadForm && !!leadFormCtas?.length && isPartnerListing;
  }

  function isPhoneButton() {
    return !!phoneNumber && !isPrivatePartyListing;
  }

  function isPrequalificationButton() {
    return isUsed && !isPartnerListing && !isPrivatePartyListing;
  }

  function isLeadFormButtonWithPhone() {
    return isLeadFormButton() && isPhoneButton();
  }

  function getPhoneButtonConfig() {
    return { type: BUTTON_TYPES.PHONE, payload: { phoneNumber } };
  }

  function getLeadFormButtonConfig() {
    const leadFormData = leadFormCtas[0];
    const challengeLeadFormData =
      isShop5146NciCopyChallenge && leadFormData?.type === CTA_TYPE.NEW.BASE
        ? { ...leadFormData, text: CTA_TEXT.CHECK_AVAILABILITY }
        : leadFormData;

    return { type: BUTTON_TYPES.LEAD_FORM, payload: { leadFormData: challengeLeadFormData } };
  }

  function constructPurchaseButtons() {
    if (ted7485Recipe === 'chal-1' && isPrivatePartyListing) {
      return [{ type: BUTTON_TYPES.CONTACT_SELLER }, { type: BUTTON_TYPES.PURCHASE }];
    } else if (['chal-2', 'chal-3'].includes(ted7485Recipe) && isPrivatePartyListing) {
      return [{ type: BUTTON_TYPES.PURCHASE }, { type: BUTTON_TYPES.CONTACT_SELLER }];
    }
    return [{ type: BUTTON_TYPES.PURCHASE }];
  }

  const conditions = cond([
    [isPurchaseButton, () => constructPurchaseButtons()], // Caramel dealer or private party listing
    [isDeliveryButton, () => [{ type: BUTTON_TYPES.DELIVERY }]],
    [isLeadFormButtonWithPhone, () => [getPhoneButtonConfig(), getLeadFormButtonConfig()]],
    [isLeadFormButton, () => [getLeadFormButtonConfig()]],
    [isPrequalificationButton, () => [{ type: BUTTON_TYPES.PREQUALIFY }]],
    [isPhoneButton, () => [getPhoneButtonConfig()]],
    [stubTrue, () => []],
  ]);

  return flow(conditions, compact)();
};
